import React, { useEffect, useContext } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./routes";
import { loadFontFamily, getLocationParamer } from "./utils/common";
import configLoader from './utils/configLoader';
import { LoadScripts, TrackPageView } from "./utils/adobeLaunch";
import ErorPopup from "@/components/ErrorPopup";
import { MyContext } from "@/context.js";
import ToastProvider from "@/components/Common/WcipToast";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
// 引入VConsole
import VConsole from "vconsole";

// 或者使用条件初始化（推荐在生产环境中使用）
if (window.globalConfig.useVconsole) {
    new VConsole();
}
function App() {
    const { errorMessage } = useContext(MyContext);
    const { i18n } = useTranslation();

    const loadConfig = async () => {
      const isPassod = getLocationParamer("bypasseod");

      await configLoader.loadConfig();

      if (configLoader?.isMaintenanceMode() && isPassod !== 'true') {
        // to new url
        window.location.href = "https://is.hkjc.com/special/notice/service_suspension/message_upgrade.html "
      }
    };

    

    // Adobe Launch
    useEffect(() => {
        loadConfig();
        //splunk log enhancement
        const appTraceId = localStorage.getItem("app-trace-id")
            ? localStorage.getItem("app-trace-id")
            : uuidv4();
        localStorage.setItem("app-trace-id", appTraceId);

        let lastUrl = window.location.href;

        const handleRouteChange = () => {
            if (window.location.href !== lastUrl) {
                lastUrl = window.location.href;
                try {
                    window.adobeDataLayer.pop(); // reset pageview
                    TrackPageView(i18n.language);
                } catch (error) {
                    console.error("Error in adobe launch", error);
                }
            }
        };

        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;

        window.addEventListener("popstate", handleRouteChange);
        window.history.pushState = function (...args) {
            const result = originalPushState.apply(this, args);
            handleRouteChange();
            return result;
        };
        window.history.replaceState = function (...args) {
            const result = originalReplaceState.apply(this, args);
            handleRouteChange();
            return result;
        };

        // Initial TrackPageView on first load
        handleRouteChange();

        const scriptUrls = [
            window.globalConfig.VITE_ADOBE_VISITOR_API_URL,
            window.globalConfig.VITE_ADOBE_LAUNCH_URL,
        ];

        LoadScripts(scriptUrls, () => {
            setTimeout(() => {
                TrackPageView(i18n.language); // adobe launch initial call, redundant if already called in handleRouteChange but kept for safety
            }, 300); // Delay TrackPageView by 0.3s
        });

        if (window.location.pathname.includes("/member")) {
            ["Prata", "Montserrat"].forEach((n) => {
                const existingLink = document.getElementById(n);
                if (existingLink) {
                    document.head.removeChild(existingLink);
                }
                loadFontFamily(n);
            });
        }

        return () => {
            // Clean up overrides and event listeners on unmount
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
            window.removeEventListener("popstate", handleRouteChange);
        };
    }, []);

    return (
        <>
            {!!errorMessage && <ErorPopup />}
            <ToastProvider>
                <RouterProvider router={router} />
            </ToastProvider>
        </>
    );
}

export default App;
